import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {RelatedCost} from "../models/basic/related-cost";
import {AxiosResponse} from "axios";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {CostAllocation} from "../models/basic/cost-allocation";

export type CostAllocationFilter = Filters & {
    category?: string,
    client?: string,
    project?: string,
    initial_date?: string,
    final_date?: string,
    ordering?: string,
};

export class CostAllocationtService extends AbstractService<CostAllocation> {

    constructor() {
        super(URLS.REPORT_COST_ALLOCATION);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.client === "0") {
            delete processedFilter.client;
        }

        if (processedFilter?.project === "0") {
            delete processedFilter.project;
        }

        if (processedFilter?.category === "0") {
            delete processedFilter.category;
        }

        return processedFilter;
    }

}
